// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { Modal } from "react-bootstrap";
// import moment from "moment";
// import "moment-timezone";

// import {
//     setLoading as setOffersLoading,
//     setFeedbacks as setOffers,
//     setError,
// } from "../../features/common/feedbackSlice";

// import { deleteFlightHomePageOfferById, getFlightHomePageOfferList } from "../../services/userservice";

// //  Offers Management
// const OffersManagementList = () => {
//     const [currentPage, setCurrentPage] = useState(1);
//     const [rowsPerPage, setRowsPerPage] = useState(10);
//     const [searchTerm, setSearchTerm] = useState("");
//     const { feedbacks: flightHomePageOffers, loading, error } = useSelector(
//         (state) => state?.feedback
//     );

//     const [showModal, setShowModal] = useState(false);
//     const [selectedOfferId, setSelectedOfferId] = useState(null);
//     const [deletedOffer, setDeletedOffer] = useState("");
//     const dispatch = useDispatch();

//     useEffect(() => {
//         const fetchOffersData = async () => {
//             try {
//                 dispatch(setOffersLoading());
//                 const response = await getFlightHomePageOfferList();
//                 dispatch(setOffers(response));
//             } catch (error) {
//                 dispatch(setError(error.message));
//             }
//         };
//         fetchOffersData();
//     }, [dispatch, deletedOffer]);

//     const handleSearchChange = (event) => {
//         setSearchTerm(event.target.value);
//     };

//     // ✅ Filter offers based on search
//     const filteredOffers = (flightHomePageOffers || []).filter(
//         (offer) =>
//             offer?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             offer?.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             offer?.content?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             offer?.holiday_destination?.name
//                 ?.toLowerCase()
//                 .includes(searchTerm.toLowerCase()) ||
//             offer?.packageCategories?.some((cat) =>
//                 cat?.name?.toLowerCase().includes(searchTerm.toLowerCase())
//             )
//     );

//     // if (loading) return <div>Loading...</div>;
//     // if (error) return <div>Error: {error}</div>;

//     const handleDelete = async () => {
//         try {
//             const deleteResponse = await deleteFlightHomePageOfferById(selectedOfferId);
//             if (deleteResponse.status === 200 || deleteResponse.status === 201) {
//                 setDeletedOffer(selectedOfferId);
//                 closeModal();
//             } else {
//                 setError(deleteResponse.message || "Failed to delete offer");
//             }
//         } catch (error) {
//             alert("You are not authorized to delete this offer");
//         }
//     };

//     const openModal = (offerId) => {
//         setSelectedOfferId(offerId);
//         setShowModal(true);
//     };

//     const closeModal = () => {
//         setShowModal(false);
//     };

//     const confirmDelete = async () => {
//         await handleDelete(selectedOfferId);
//         closeModal();
//     };

//     const indexOfLastOffer = currentPage * rowsPerPage;
//     const indexOfFirstOffer = indexOfLastOffer - rowsPerPage;
//     const offerList = filteredOffers.slice(indexOfFirstOffer, indexOfLastOffer);

//     const totalPages = Math.ceil(filteredOffers.length / rowsPerPage);

//     const renderPageNumbers = () => {
//         const pages = [];
//         if (totalPages <= 10) {
//             for (let i = 1; i <= totalPages; i++) pages.push(i);
//         } else {
//             pages.push(1, 2, 3);
//             if (currentPage > 5) pages.push("...");
//             const start = Math.max(4, currentPage - 1);
//             const end = Math.min(totalPages - 3, currentPage + 1);
//             for (let i = start; i <= end; i++) if (!pages.includes(i)) pages.push(i);
//             if (currentPage < totalPages - 4) pages.push("...");
//             pages.push(totalPages - 2, totalPages - 1, totalPages);
//         }

//         return pages.map((page, index) => (
//             <li
//                 key={index}
//                 className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""
//                     }`}
//             >
//                 {page === "..." ? (
//                     <span className="page-link">...</span>
//                 ) : (
//                     <button className="page-link" onClick={() => setCurrentPage(page)}>
//                         {page}
//                     </button>
//                 )}
//             </li>
//         ));
//     };

//     return (
//         <div className="content-wrapper">
//             <div className="content-header">
//                 <div className="container-fluid">
//                     <div className="row mb-2">
//                         <div className="col-sm-6">
//                             <h1 className="m-0">Offers Management List</h1>
//                         </div>
//                         <div className="col-sm-6">
//                             <ol className="breadcrumb float-sm-right">
//                                 <li className="breadcrumb-item">
//                                     <Link to="/dashboard">Home</Link>
//                                 </li>
//                                 <li className="breadcrumb-item active">Offers Management List</li>
//                             </ol>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <section className="content">
//                 <div className="container-fluid">
//                     <div className="row">
//                         <div className="col-md-12">
//                             <div className="card">
//                                 {/* Header */}
//                                 <div className="card-header d-md-flex align-items-center justify-content-end">
//                                     <Link
//                                         to="/add-offers-management"
//                                         className="btn btn-primary mb-md-0 mb-2 py-1 mr-3"
//                                     >
//                                         <i className="fas fa-plus" /> Add Offer
//                                     </Link>
//                                     <div className="card-tools">
//                                         <div
//                                             className="input-group input-group-sm"
//                                             style={{ width: "250px" }}
//                                         >
//                                             <input
//                                                 type="text"
//                                                 className="form-control float-right"
//                                                 placeholder="Search"
//                                                 value={searchTerm}
//                                                 onChange={handleSearchChange}
//                                             />
//                                             <div className="input-group-append">
//                                                 <button type="submit" className="btn btn-default">
//                                                     <i className="fas fa-search" />
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Table */}
//                                 <div className="card-body">
//                                     <div className="table-responsive">
//                                         <table className="table table-bordered table-hover">
//                                             <thead>
//                                                 <tr>
//                                                     <th>ID</th>
//                                                     <th>Title</th>
//                                                     <th>Banner</th>
//                                                     <th>Status</th>
//                                                     <th>Applicable Type</th>
//                                                     <th>Offer Type</th>
//                                                     <th>Created At</th>
//                                                     <th>Updated At</th>
//                                                     <th>Action</th>
//                                                 </tr>
//                                             </thead>
//                                             {offerList.length > 0 ? (
//                                                 <tbody>
//                                                     {offerList.map((offer) => (
//                                                         <tr key={offer.id}>
//                                                             <td>{offer.id}</td>
//                                                             <td>{offer.title}</td>
//                                                             <td>
//                                                                 <img
//                                                                     src={offer?.image}
//                                                                     alt={offer.title}
//                                                                     style={{ width: "120px", height: "60px", objectFit: "cover" }}
//                                                                 />
//                                                             </td>
//                                                             <td>
//                                                                 <span className={`badge p-2 w-100 ${offer?.status === "active" ? "badge-success" : "badge-danger"}`}>
//                                                                     {offer?.status?.charAt(0).toUpperCase() + offer?.status?.slice(1)}
//                                                                 </span>
//                                                             </td>
//                                                             <td>{offer.offer_type_name}</td>
//                                                             <td>{offer.applicable_type_name}</td>
//                                                             <td>{moment(offer.created_at).format("DD-MM-YYYY hh:mm A")}</td>
//                                                             <td>{moment(offer.updated_at).format("DD-MM-YYYY hh:mm A")}</td>
//                                                             <td>
//                                                                 <div className="d-flex align-items-center" style={{ gap: "10px" }}>
//                                                                     <Link to={`/edit-offers-management/${offer.id}`}>
//                                                                         <button className="btn btn-primary btn-sm">Edit</button>
//                                                                     </Link>
//                                                                     <button
//                                                                         className="btn btn-danger btn-sm"
//                                                                         onClick={() => openModal(offer?.id)}
//                                                                     >
//                                                                         Delete
//                                                                     </button>
//                                                                 </div>
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </tbody>
//                                             ) : (
//                                                 <tbody>
//                                                     <tr>
//                                                         <td colSpan="8" className="text-center">
//                                                             No Offers Found
//                                                         </td>
//                                                     </tr>
//                                                 </tbody>
//                                             )}
//                                         </table>
//                                     </div>

//                                     {/* Pagination */}
//                                     <div className="d-md-flex justify-content-between align-items-center mt-3">
//                                         <div>
//                                             Showing {indexOfFirstOffer + 1} to{" "}
//                                             {Math.min(indexOfLastOffer, filteredOffers.length)} of{" "}
//                                             {filteredOffers.length} entries
//                                         </div>
//                                         <nav>
//                                             <ul className="pagination mb-0">
//                                                 <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
//                                                     <button
//                                                         className="page-link"
//                                                         onClick={() => setCurrentPage(currentPage - 1)}
//                                                     >
//                                                         Previous
//                                                     </button>
//                                                 </li>
//                                                 {renderPageNumbers()}
//                                                 <li
//                                                     className={`page-item ${currentPage === totalPages ? "disabled" : ""
//                                                         }`}
//                                                 >
//                                                     <button
//                                                         className="page-link"
//                                                         onClick={() => setCurrentPage(currentPage + 1)}
//                                                     >
//                                                         Next
//                                                     </button>
//                                                 </li>
//                                             </ul>
//                                         </nav>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>

//             {/* Delete Modal */}
//             <Modal show={showModal} onHide={closeModal}>
//                 <Modal.Header closeButton>
//                     <Modal.Title>Confirm</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="text-center p-4">
//                         <h5>Are you sure you want to delete this Offer?</h5>
//                     </div>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <button className="btn btn-secondary" onClick={closeModal}>
//                         Cancel
//                     </button>
//                     <button className="btn btn-danger" onClick={confirmDelete}>
//                         OK
//                     </button>
//                 </Modal.Footer>
//             </Modal>
//         </div>
//     );
// };

// export default OffersManagementList;



import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import moment from "moment";
import "moment-timezone";

import {
    setLoading as setOffersLoading,
    setFeedbacks as setOffers,
    setError,
} from "../../features/common/feedbackSlice";

import { deleteFlightHomePageOfferById, getFlightHomePageOfferList } from "../../services/userservice";

// Offers Management
const OffersManagementList = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
    const [filters, setFilters] = useState({
        applicableType: "",
        offerType: "",
        status: ""
    });

    const { feedbacks: flightHomePageOffers, loading, error } = useSelector(
        (state) => state?.feedback
    );

    const [showModal, setShowModal] = useState(false);
    const [selectedOfferId, setSelectedOfferId] = useState(null);
    const [deletedOffer, setDeletedOffer] = useState("");
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchOffersData = async () => {
            try {
                dispatch(setOffersLoading());
                const response = await getFlightHomePageOfferList();
                dispatch(setOffers(response));
            } catch (error) {
                dispatch(setError(error.message));
            }
        };
        fetchOffersData();
    }, [dispatch, deletedOffer]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page when searching
    };

    const handleFilterChange = (filterType, value) => {
        setFilters(prev => ({
            ...prev,
            [filterType]: value
        }));
        setCurrentPage(1); // Reset to first page when filtering
    };

    const resetFilters = () => {
        setSearchTerm("");
        setFilters({
            applicableType: "",
            offerType: "",
            status: ""
        });
        setCurrentPage(1);
    };

    // Get unique values for filter dropdowns
    const getUniqueValues = (key) => {
        const values = (flightHomePageOffers || [])
            .map(offer => offer[key])
            .filter((value, index, self) => value && self.indexOf(value) === index);
        return values.sort();
    };

    // ✅ Filter offers based on search and filters
    const filteredOffers = (flightHomePageOffers || []).filter((offer) => {
        // Search filter
        const matchesSearch =
            offer?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            offer?.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            offer?.content?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            offer?.holiday_destination?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            offer?.packageCategories?.some((cat) =>
                cat?.name?.toLowerCase().includes(searchTerm.toLowerCase())
            );

        // Additional filters
        const matchesApplicableType = !filters.applicableType || offer.applicable_type_name === filters.applicableType;
        const matchesOfferType = !filters.offerType || offer.offer_type_name === filters.offerType;
        const matchesStatus = !filters.status || offer.status === filters.status;

        return matchesSearch && matchesApplicableType && matchesOfferType && matchesStatus;
    });

    const handleDelete = async () => {
        try {
            const deleteResponse = await deleteFlightHomePageOfferById(selectedOfferId);
            if (deleteResponse.status === 200 || deleteResponse.status === 201) {
                setDeletedOffer(selectedOfferId);
                closeModal();
            } else {
                setError(deleteResponse.message || "Failed to delete offer");
            }
        } catch (error) {
            alert("You are not authorized to delete this offer");
        }
    };

    const openModal = (offerId) => {
        setSelectedOfferId(offerId);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const confirmDelete = async () => {
        await handleDelete(selectedOfferId);
        closeModal();
    };

    const indexOfLastOffer = currentPage * rowsPerPage;
    const indexOfFirstOffer = indexOfLastOffer - rowsPerPage;
    const offerList = filteredOffers.slice(indexOfFirstOffer, indexOfLastOffer);

    const totalPages = Math.ceil(filteredOffers.length / rowsPerPage);

    const renderPageNumbers = () => {
        const pages = [];
        if (totalPages <= 10) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            pages.push(1, 2, 3);
            if (currentPage > 5) pages.push("...");
            const start = Math.max(4, currentPage - 1);
            const end = Math.min(totalPages - 3, currentPage + 1);
            for (let i = start; i <= end; i++) if (!pages.includes(i)) pages.push(i);
            if (currentPage < totalPages - 4) pages.push("...");
            pages.push(totalPages - 2, totalPages - 1, totalPages);
        }

        return pages.map((page, index) => (
            <li
                key={index}
                className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""
                    }`}
            >
                {page === "..." ? (
                    <span className="page-link">...</span>
                ) : (
                    <button className="page-link" onClick={() => setCurrentPage(page)}>
                        {page}
                    </button>
                )}
            </li>
        ));
    };

    // Check if any filter is active
    const isFilterActive = searchTerm || filters.applicableType || filters.offerType || filters.status;

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Offers Management List</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item active">Offers Management List</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                {/* Header with Search and Filters */}
                                <div className="card-header">


                                    <div className="row mt-3">
                                        <div className="col-md-3">
                                            <div className="d-flex justify-content-end flex-wrap gap-2">
                                                <div className="form-group">
                                                    <label>Search</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search..."
                                                        value={searchTerm}
                                                        onChange={handleSearchChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Applicable Type</label>
                                                <select
                                                    className="form-control"
                                                    value={filters.applicableType}
                                                    onChange={(e) => handleFilterChange('applicableType', e.target.value)}
                                                >
                                                    <option value="">All Types</option>
                                                    {getUniqueValues('applicable_type_name').map(type => (
                                                        <option key={type} value={type}>
                                                            {type}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Offer Type</label>
                                                <select
                                                    className="form-control"
                                                    value={filters.offerType}
                                                    onChange={(e) => handleFilterChange('offerType', e.target.value)}
                                                >
                                                    <option value="">All Offer Types</option>
                                                    {getUniqueValues('offer_type_name').map(type => (
                                                        <option key={type} value={type}>
                                                            {type}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Status</label>
                                                <select
                                                    className="form-control"
                                                    value={filters.status}
                                                    onChange={(e) => handleFilterChange('status', e.target.value)}
                                                >
                                                    <option value="">All Status</option>
                                                    <option value="active">Active</option>
                                                    <option value="inactive">Inactive</option>
                                                </select>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="d-flex justify-content-end flex-wrap gap-2">
                                        {isFilterActive && (
                                            <button
                                                className="btn btn-primary mb-2 mx-4"
                                                onClick={resetFilters}
                                                title="Reset all filters"
                                            >
                                                <i className="fas fa-refresh" /> Reset
                                            </button>
                                        )}

                                        <Link
                                            to="/add-offers-management"
                                            className="btn btn-primary mb-2"
                                        >
                                            <i className="fas fa-plus" /> Add Offer
                                        </Link>
                                    </div>
                                </div>

                                {/* Table */}
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Title</th>
                                                    <th>Banner</th>
                                                    <th>Status</th>
                                                    <th>Applicable Type</th>
                                                    <th>Offer Type</th>
                                                    <th>Created At</th>
                                                    <th>Updated At</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            {offerList.length > 0 ? (
                                                <tbody>
                                                    {offerList.map((offer) => (
                                                        <tr key={offer.id}>
                                                            <td>{offer.id}</td>
                                                            <td>{offer.title}</td>
                                                            <td>
                                                                <img
                                                                    src={offer?.image}
                                                                    alt={offer.title}
                                                                    style={{ width: "120px", height: "60px", objectFit: "cover" }}
                                                                />
                                                            </td>
                                                            <td>
                                                                <span className={`badge p-2 w-100 ${offer?.status === "active" ? "badge-success" : "badge-danger"}`}>
                                                                    {offer?.status?.charAt(0).toUpperCase() + offer?.status?.slice(1)}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span className="badge badge-info">
                                                                    {offer.applicable_type_name}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span className="badge badge-primary">
                                                                    {offer.offer_type_name}
                                                                </span>
                                                            </td>
                                                            <td>{moment(offer.created_at).format("DD-MM-YYYY hh:mm A")}</td>
                                                            <td>{moment(offer.updated_at).format("DD-MM-YYYY hh:mm A")}</td>
                                                            <td>
                                                                <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                                                    <Link to={`/edit-offers-management/${offer.id}`}>
                                                                        <button className="btn btn-primary btn-sm">Edit</button>
                                                                    </Link>
                                                                    <button
                                                                        className="btn btn-danger btn-sm"
                                                                        onClick={() => openModal(offer?.id)}
                                                                    >
                                                                        Delete
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            ) : (
                                                <tbody>
                                                    <tr>
                                                        <td colSpan="9" className="text-center py-4">
                                                            <div className="text-muted">
                                                                <i className="fas fa-inbox fa-2x mb-2"></i>
                                                                <br />
                                                                No Offers Found
                                                                {isFilterActive && (
                                                                    <div>
                                                                        <small>Try adjusting your filters</small>
                                                                        <br />
                                                                        <button
                                                                            className="btn btn-sm btn-outline-primary mt-2"
                                                                            onClick={resetFilters}
                                                                        >
                                                                            Reset Filters
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            )}
                                        </table>
                                    </div>

                                    {/* Pagination */}
                                    <div className="d-md-flex justify-content-between align-items-center mt-3">
                                        <div>
                                            Showing {indexOfFirstOffer + 1} to{" "}
                                            {Math.min(indexOfLastOffer, filteredOffers.length)} of{" "}
                                            {filteredOffers.length} entries
                                        </div>
                                        <nav>
                                            <ul className="pagination mb-0">
                                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => setCurrentPage(currentPage - 1)}
                                                    >
                                                        Previous
                                                    </button>
                                                </li>
                                                {renderPageNumbers()}
                                                <li
                                                    className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                                        }`}
                                                >
                                                    <button
                                                        className="page-link"
                                                        onClick={() => setCurrentPage(currentPage + 1)}
                                                    >
                                                        Next
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Delete Modal */}
            <Modal show={showModal} onHide={closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center p-4">
                        <h5>Are you sure you want to delete this Offer?</h5>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={closeModal}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirmDelete}>
                        OK
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default OffersManagementList;
